import { z } from 'zod'

export const zFavoriteMultipleListItem = z.object({
  id: z.uuid(),
  name: z.string(),
  customerId: z.string(),
  isDefault: z.boolean(),
  creationDate: z.string().datetime().nullable(),
  createdBy: z.string().nullable(),
  createdByUsername: z.string().nullable(),
  lastModifiedDate: z.string().datetime().nullable(),
  lastModifiedBy: z.string(),
  lastModifiedByUsername: z.string(),
})

export type FavoriteMultipleListItemSchema = z.infer<typeof zFavoriteMultipleListItem>
